import { render, staticRenderFns } from "./FinalScreen.vue?vue&type=template&id=a25c1934&scoped=true&"
var script = {}
import style0 from "./FinalScreen.vue?vue&type=style&index=0&id=a25c1934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25c1934",
  null
  
)

export default component.exports